import { createContext, useContext, useState, useEffect } from 'react';

const ActiveSessionContext = createContext();

export const useActiveSession = () => useContext(ActiveSessionContext);

export const ActiveSessionProvider = ({ children }) => {
  const [activeSession, setActiveSession] = useState(null);

  // 🔁 Rehydrate on mount
  useEffect(() => {
    const saved = localStorage.getItem('currentActiveSession');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed?.startedAt) {
          setActiveSession(parsed);
          console.log('[ActiveSessionProvider] Rehydrated from localStorage:', parsed);
        }
      } catch (err) {
        console.warn('[ActiveSessionProvider] Failed to parse saved session:', err);
      }
    }
  }, []);

  // 💾 Save to localStorage whenever it changes
  useEffect(() => {
    if (activeSession) {
      localStorage.setItem('currentActiveSession', JSON.stringify(activeSession));
    } else {
      localStorage.removeItem('currentActiveSession');
    }
  }, [activeSession]);

  return (
    <ActiveSessionContext.Provider value={{ activeSession, setActiveSession }}>
      {children}
    </ActiveSessionContext.Provider>
  );
};
